export const handlePageChange = (setCurrentPage) => (event, newPage) => {
    setCurrentPage(newPage);
};

export const handleItemsPerPageChange = (setItemsPerPage, setCurrentPage) => (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
};
